(() => {
  function init(root) {
    if (root.dataset.unlazyV2Ready) return;
    root.dataset.unlazyV2Ready = 'true';
    const config = JSON.parse(root.querySelector('[data-unlazy-v2-config]').textContent);
    const button = root.querySelector('[data-unlazy-v2-copy]');
    const status = root.querySelector('[data-unlazy-v2-status]');
    const fallback = root.querySelector('[data-unlazy-v2-fallback]');
    const textarea = fallback.querySelector('textarea');
    textarea.value = config.prompt;
    button.disabled = false;
    button.addEventListener('click', async () => {
      status.textContent = '';
      button.disabled = true;
      try {
        await navigator.clipboard.writeText(config.prompt);
        fallback.hidden = true;
        status.textContent = config.copied;
      } catch (error) {
        status.textContent = config.error;
        fallback.hidden = false;
        textarea.focus();
        textarea.select();
      } finally {
        button.disabled = false;
      }
    });
    const motion = root.querySelector('[data-unlazy-v2-motion]');
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) motion.hidden = false;
    motion.addEventListener('click', () => {
      const paused = root.classList.toggle('unlazy-v2-paused');
      motion.textContent = paused ? config.resume : config.pause;
      motion.setAttribute('aria-pressed', String(paused));
    });
  }

  document.querySelectorAll('[data-unlazy-v2]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-unlazy-v2]').forEach(init);
  });
})();
